import { isAssetCoveredByRfSubscription } from '../../../rfSubscriptionPredicates';
import acquisitionMode from '../../../../support/acquisitionMode';
import type { BannerRule } from '../types';

export const ENTERPRISE_CONTACT_SALES_FORM_ID = '701Pm00001SwXREIA3';
export const ENTERPRISE_CONTACT_SALES_FORM_SOURCE =
  'GI_Site_EnterpriseService ';

const assetNotCoveredRule: BannerRule = (
  { hasRfSubscription, downloadAgreements, siteMap, mode },
  t
) => {
  if (!hasRfSubscription) return null;
  if (isAssetCoveredByRfSubscription(downloadAgreements)) return null;
  if (mode === acquisitionMode.MODAL) return null;

  return {
    severity: 'info',
    heading: t('asset_not_included_in_subscription'),
    description: t('contact_us_to_expand_content_access'),
    linkText: t('contact_us'),
    linkUrl: siteMap.enterpriseContactSalesForm(
      ENTERPRISE_CONTACT_SALES_FORM_ID,
      ENTERPRISE_CONTACT_SALES_FORM_SOURCE
    ),
  };
};

export default assetNotCoveredRule;
